module.exports = __webpack_public_path__ + "img/22_75.6073356e.png";